import { render } from "./CardSkeleton.vue?vue&type=template&id=ebbdf63c&scoped=true"
const script = {}

import "./CardSkeleton.vue?vue&type=style&index=0&id=ebbdf63c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebbdf63c"]])

export default __exports__